import { Component, Input } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { MatTooltipModule } from '@angular/material/tooltip';
import { TranslateModule } from '@ngx-translate/core';

// Задача 5/Фаза 5: the one shared "i" explanation icon for every KPI card and chart/table title
// across all 7 Analytics screens - ports the matTooltip+"wide-tooltip" pattern already used
// outside Analytics (client-clipping-stats.component.html's "stat-info-icon") into a single
// reusable component instead of each screen copy-pasting the mat-icon/matTooltip markup and its
// own local sizing CSS. `.wide-tooltip` is a global style (styles.scss) - no import needed here.
// `extraKey` exists only for the rare KPI card whose text is the shared term's own wording PLUS a
// screen-specific caveat (e.g. Topics' Visibility/Impact/Net Sentiment cards add "only mentions
// with a topic") - it appends a second translated sentence rather than duplicating the shared
// sentence under a new composite key, keeping "one key per shared term" intact.
@Component({
	selector: 'app-info-icon',
	standalone: true,
	imports: [MatIconModule, MatTooltipModule, TranslateModule],
	template: `<mat-icon
		class="info-icon"
		matTooltipClass="wide-tooltip"
		matTooltipPosition="above"
		[matTooltip]="extraKey ? (key | translate) + ' ' + (extraKey | translate) : (key | translate)"
		>info_outline</mat-icon
	>`,
	styles: [
		`
			.info-icon {
				display: inline-flex;
				align-items: center;
				justify-content: center;
				width: 14px;
				height: 14px;
				font-size: 14px;
				line-height: 14px;
				color: var(--ink-subtle, #5f6470);
				cursor: help;
				vertical-align: middle;
			}
		`,
	],
})
export class InfoIconComponent {
	@Input({ required: true }) key!: string;
	@Input() extraKey?: string;
}
